import { forwardRef } from "react";
import { IconPropsType, Ref } from "./IconPropsType";

const Instagram = forwardRef<Ref, IconPropsType>(
  ({ color = "currentColor", size, ...rest }, ref) => {
    return (
      <svg
        width={size ?? 20}
        height={size ?? 20}
        viewBox="0 0 20 20"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M7.49999 18.3333H12.5C16.6667 18.3333 18.3333 16.6666 18.3333 12.5V7.49996C18.3333 3.33329 16.6667 1.66663 12.5 1.66663H7.49999C3.33332 1.66663 1.66666 3.33329 1.66666 7.49996V12.5C1.66666 16.6666 3.33332 18.3333 7.49999 18.3333Z"
          stroke={color}
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M10 12.9167C11.6108 12.9167 12.9167 11.6109 12.9167 10C12.9167 8.38921 11.6108 7.08337 10 7.08337C8.38918 7.08337 7.08334 8.38921 7.08334 10C7.08334 11.6109 8.38918 12.9167 10 12.9167Z"
          stroke={color}
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M14.6968 5.83329H14.7064"
          stroke={color}
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    );
  },
);

export default Instagram;
